module.exports = __webpack_public_path__ + "img/a7ff4f9.jpg";